import { Box } from '@mui/material';
import React from 'react';

import ActionDrawer from '../ActionDrawer';
import { MobileTitle } from '../Typography';

export interface FilterDrawerProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children?: React.ReactNode;
}

const FilterDrawer: React.FC<FilterDrawerProps> = ({
  open,
  onClose,
  title = 'Filtros',
  children,
}) => (
  <ActionDrawer open={open} onClose={onClose}>
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        pt: 1,
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <MobileTitle gutterBottom>{title}</MobileTitle>
    </Box>
    {children}
  </ActionDrawer>
);

export default FilterDrawer;
